<template>
  <div class="form-container">
    <el-card class="header-card"></el-card>
    <el-card class="desc-card">
      <div class="header" dir="auto" role="heading" aria-level="1">Recruitment Information for TruMatrix AI<br><span></span></div>
      <div class="text">
        &nbsp;&nbsp;&nbsp;&nbsp;<span style="font-weight: bold;">TruMatrix AI </span>specializes in  <span style="font-weight: bold;">AI-driven music creation and promotion</span>, helping music producers enhance their work and intelligently market their tracks to make them go viral.<br>

        &nbsp;&nbsp;&nbsp;&nbsp;Music producers pay for promotion, while  <span style="font-weight: bold;">remote part-time workers</span> listen to, review, and rate music, boosting streams and downloads to help tracks reach a wider audience.<br>

        &nbsp;&nbsp;&nbsp;&nbsp;We are building an <span style="font-weight: bold;">AI-powered music ecosystem</span>, giving artists greater exposure while enabling part-time workers to earn effortlessly—blending <span style="font-weight: bold;">technology, creativity, and business</span>.<br><br>
       
        ✅  <span style="font-weight: bold;"> Work from Home - Now Hiring Music Reviewers：</span><br>
        <span style="font-weight: bold;padding-left: 20px;">Job Title:</span> &nbsp;&nbsp;Remote Music Reviewer<br>
        <span style="font-weight: bold;padding-left: 20px;">Job Description:</span> &nbsp;&nbsp;Listen to various types of music, write honest reviews, and help increase music downloads and streams.<br>
        <span style="font-weight: bold;padding-left: 20px;"> Pay:</span>&nbsp;&nbsp; $300-$500 per day, paid daily!<br>
        <span style="font-weight: bold;padding-left: 20px;">Requirements:</span> &nbsp;&nbsp;U.S. residents only (SSN verification required)<br>
        <span style="font-weight: bold;padding-left: 20px;"> Benefits:</span>&nbsp;&nbsp; Flexible hours, no experience needed!<br><br>
        📩<span style="font-weight: bold;"> Apply Now and Get Paid to Enjoy Music!：</span><br><br>
      </div>
      <el-form :model="form" ref="ruleFormRef" :rules="rules"  label-position="top">
        <el-form-item label="Full Name:" prop="name" class="bold-label">
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item label="Phone:" prop="phone"  class="bold-label">
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item label="WhatsApp:" prop="whatsapp"  class="bold-label">
          <el-input v-model="form.whatsapp" /><el-text class="mx-1" type="danger">You must register a Whatsapp number, our HR will contact you via Whatsapp!</el-text>
        </el-form-item>
        <el-form-item label="Age Range:" prop="age"  class="bold-label">
          <el-radio-group v-model="form.age">
            <el-radio :value="1">25-30</el-radio>
            <el-radio :value="2">31-40</el-radio>
            <el-radio :value="3">41-50</el-radio>
            <el-radio :value="4">51-65</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="Live City:" prop="city" class="bold-label">
          <el-input v-model="form.city" />
        </el-form-item>
        <el-form-item label="Introduce yourself:"  class="bold-label">
          <el-input
              v-model="form.intro"
              rows="5"
              type="textarea"
              placeholder="Introduce yourself"
            />
        </el-form-item>
        <el-button type="primary" :loading="loading" @click="submitForm">Submit</el-button> 
        <el-text class="mx-1" type="success" v-if="result==1" style="margin-left: 10px;">Form submitted successfully!</el-text>
        <el-text class="mx-1" type="danger" v-if="result==2" style="margin-left: 10px;">Server Error!</el-text>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive,ref } from 'vue'
import axios from 'axios';
import { ElForm, ElFormItem, ElInput, ElButton, ElMessage } from 'element-plus';
const ruleFormRef = ref(null)
const loading = ref(false);
const result = ref(0);
const form = reactive({
  name: '',
  whatsapp: '',
  phone:'',
  age: '',
  city:'',
  intro: '',
})

const rules =reactive({
   name: [
      { required: true, message: "Full Name must be filled in", trigger: "blur" }
    ],
    age: [
      { required: true, message: "Age Range must be filled in", trigger: "blur" }
    ],
    whatsapp: [
      { required: true, message: "WhatsApp must be filled in", trigger: "blur" }
    ],
    phone: [
      { required: true, message: "Phone must be filled in", trigger: "blur" }
    ],
    city: [
      { required: true, message: "Live City must be filled in", trigger: "blur" }
    ]
  })

const submitForm = () => {
  ruleFormRef.value.validate((valid, fields) => {
    if (valid) {
      loading.value = true;
      axios.post('/form-service/form/submit', form)
        .then((response) => {
          loading.value = false;
          ElMessage.success('Form submitted successfully');
          console.log(response.data);  // 后台返回的响应数据
          form.name='';
          form.whatsapp='';
          form.phone='';
          form.age='';
          form.city='';
          form.intro='';
          result.value=1
        }).catch((error) => {
          loading.value = false;
          ElMessage.error('Server Error');
          console.error(error);
          result.value=2
        });
    } else {
      console.log('error submit!', fields)
    }
  })
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bold-label {
  font-weight: bold;
}
.form-container {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
}
.header-card {
    max-height: 22.5vw;
    max-width: 90vw;
    height: 320px;
    width: 640px;
    background-image: url('../assets/3.jpg');
    background-size: cover;
    background-position: center;
    border: 1px solid rgb(218, 220, 224);
    border-radius: 8px 8px 0 0;
    margin-top: 12px;
    margin: auto;
    max-width: 90vw;
    width: 640px;
}
.desc-card {
    margin: auto;
    max-width: 90vw;
    width: 640px;
    background-color: transparent;
    box-shadow: none;
    margin-bottom: 0;
    padding-bottom: 0;
    word-wrap: break-word;
    color: rgb(32, 33, 36);
    text-align: left;
}

.desc-card .header{
    font-family: 'docs-Roboto';
    font-weight: 500;
    font-size: 20pt;
    line-height: 2;
    letter-spacing: 0;
}

.desc-card .text{
  font-family: 'docs-Roboto';
    font-weight: 400;
    font-size: 11pt;
    line-height: 1.6;
    letter-spacing: 0;
}
.radio-group-vertical {
  display: flex;
  flex-direction: column;
  margin-left: 0px;
}

.el-radio:last-child {
     margin-left: 0 !important; 
}

</style>
